import React, {useContext, useEffect} from "react";
import "./Buttons.css";
import {useTranslation} from "react-i18next";
import {AppContext} from "../../context/AppContext";
import GeneratePDFButton from "./GeneratePDFButton";
import {scrollToTop} from '../../utility/smoothScroll';
import {DebugContext} from "../../context/DebugContext";

const Buttons = ({handleButtonClick, validateForm}) => {
    const {currentPage, handlePageChange} = useContext(AppContext);
    const { debugEnabled, debugLog } = useContext(DebugContext);
    const {t} = useTranslation();

    const changePage = (page) => {
        window.scrollTo({top: 0, left: 0});
        handlePageChange(page);
        handleButtonClick();
    }

    const goToPreviousPage = () => {
        const page = Math.max(currentPage - 1, 0);

        debugLog(`handleClick: currentPage: ${currentPage}, targetPage: ${page}`);
        changePage(page);
    }

    const goToNextPage = () => {
        const page = currentPage + 1;

        debugLog(`handleClick: currentPage: ${currentPage}, targetPage: ${page}`);

        if (!validateForm()) {
            debugLog(`handleClick: form is not valid, skipping to top of page`);
            scrollToTop();
            return;
        }

        changePage(page);
    }

    useEffect(() => {
        if(debugEnabled){
            window.goToPreviousPage = goToPreviousPage;
        }
    }, []);
    
    const devButtons = () => {
        if (debugEnabled) {
            return (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "10em",
                    backgroundColor: "red",
                    padding: "10px 10px",
                    textAlign: "center"
                }}>
                    <strong>DEV</strong>
                    <button type="button" style={{padding: "5px"}} onClick={() => changePage(currentPage - 1)}>Previous Page <br/> (Skip validation)</button>
                    <button type="button" style={{padding: "5px"}} onClick={() => validateForm()}>Validate Form</button>
                    <button type="button" style={{padding: "5px"}} onClick={() => changePage(currentPage + 1)}>Next Page <br/> (Skip validation)</button>
                </div>
            )
        }
    }

    if (currentPage === 0) {
        return (
            <div className="btn-box no-back-btn">

                {devButtons()}

                <button
                    type="button"
                    className="btn-next"
                    onClick={() => goToNextPage()}
                >
                    {t("global.btn.next")}
                </button>
            </div>
        );
    }

    return (
        <div className="btn-box">

            {devButtons()}

            <button
                type="button"
                className="btn-back"
                onClick={() => goToPreviousPage()}
            >
                {t("global.btn.back")}
            </button>
            {(currentPage === 1 || currentPage === 2) && (
                <button
                    type="button"
                    className="btn-next"
                    onClick={() => goToNextPage()}
                >
                    {t("global.btn.next")}
                </button>
            )}
            {currentPage === 3 && (
                <GeneratePDFButton
                    validateForm={validateForm}
                    handleButtonClick={handleButtonClick}
                />
            )}
        </div>
    );
};

export default Buttons;
